import http from '../../services/http-common';

class ChangePasswordService {
    checkOldPassword(value='not matched' ,ID) {
        let queryParams = new URLSearchParams({PWord:value,UserID:ID}).toString();

    return http.get(`/ChangePassword/checkPassword?${queryParams}`);
    }
   
    updatePassword(value ,ID) {
        let queryParams = new URLSearchParams({PWord:value,UserID:ID}).toString();

    return http.get(`/ChangePassword/updatePassword?${queryParams}`);
    }
   
}

export default new ChangePasswordService();